export default {
  PRODUCT_REPEATER_CLASS:
    'products content-wrap product-archive grid-cols grid-ss-col-2 grid-sm-col-3 grid-lg-col-4 woo-archive-action-on-hover woo-archive-btn-text woo-archive-image-hover-none',

  BUTTON_PRIMARY_CLASS: 'cm_button cm_button__primary button',
  BUTTON_SECONDARY_CLASS: 'cm_button cm_button__secondary button button-style-outline',

  SEARCH_BOX_PLACEHOLDER: 'Search products...',
  SEARCH_BOX_DIALOG_OPENING_ICON_CLASS: 'search-toggle-icon',

  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',

  YOU_MAY_ALSO_LIKE: 'Related products',
  RELATED_PRODUCT_LIST_CLASS:
    'products content-wrap product-archive grid-cols grid-ss-col-2 grid-sm-col-3 grid-lg-col-4 woo-archive-action-on-hover woo-archive-btn-text',

  FACET_TOGGLE_LABEL: 'Filter by vehicle',
};
